import { BffApiClientMolecule } from "@/app/api-client/store"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { getCollectionStatisticQueryParams } from "./collection-statistic-query"

export const getCollectionStatisticMoleculeReatom = (
  collectionId: CollectionId,
) => {
  return molecule((mol) => {
    const bffApiClient = mol(BffApiClientMolecule)

    // Computed: suspended statistic query params for useSuspenseQuery
    const suspendedStatisticQueryParams = computed(
      () => ({
        ...getCollectionStatisticQueryParams(bffApiClient, {
          id: collectionId,
        }),
        refetchInterval: 3000,
        retry: false,
      }),
      `suspendedStatisticQueryParams-${collectionId}`,
    )

    // Computed: statistic query params for useQuery
    const statisticQueryParams = computed(
      () =>
        ({
          ...getCollectionStatisticQueryParams(bffApiClient, {
            id: collectionId,
          }),
          retry: false,
          refetchInterval: 3000,
        }) as const,
      `statisticQueryParams-${collectionId}`,
    )

    return {
      suspendedStatisticQueryParams,
      statisticQueryParams,
    }
  })
}
